import { compose, withHandlers, withPropsOnChange, withState } from 'recompose';
import { connect } from 'react-redux';
import limitValue from '../../../common/hoc/limitValue';
import CustomTip from '../components/CustomTip';
import { getCurrentBarber } from '../../../register/tipping/selectors';

const MAX_TIP = 100000000;

const CustomTipContainer = compose(
  withState('customEnabled', 'setCustomEnabled', false),
  withState('value', 'setValue', 0),
  connect(state => ({
    currentBarber: getCurrentBarber(state),
  })),
  withHandlers({
    enableCustom: props => () => props.setCustomEnabled(true),
    onChange: props => tipAmount => props.setValue(tipAmount),
    onSubmit: props => (e) => {
      e.preventDefault();
      props.setTip(props.value);
    },
  }),
  withPropsOnChange(
    ['currentBarber'],
    (props) => {
      props.setCustomEnabled(false);
    }
  ),
  limitValue(props => (Number.isFinite(props.paymentBalance) ? props.paymentBalance : MAX_TIP)),
)(CustomTip);

export default CustomTipContainer;
